var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburgerMenu = function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 16.667"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.667h10v-2.778H0Zm0-6.944h18V6.944H0ZM0 0v2.778h25V0Z"
  })));
};
export default SvgHamburgerMenu;